import LazyVideo from '@cartwhl/ui/atoms/LazyVideo';
import Text from '@cartwhl/ui/base/Text';

import GreenLink from 'components/GreenLink';
import SectionHeader from 'components/SectionHeader';
import { CDN } from 'consts';

const dataProducts = [
  {
    title: 'Social prediction',
    videoUrl: `${CDN}01_home_page/05_motion_data_insight_section/01_social_prediction.webm`,
  },
  {
    title: 'Robotics training data',
    videoUrl: `${CDN}01_home_page/05_motion_data_insight_section/02_robotics_training_data.webm`,
  },
  {
    title: 'Sports motion analysis',
    videoUrl: `${CDN}01_home_page/05_motion_data_insight_section/03_sports_analysis.webm`,
  },
  {
    title: 'World models',
    videoUrl: `${CDN}v2_homepage_motion_data_04_world_models.webm`,
  },
];

export default function MotionDataSection() {
  return (
    <section className="py-(--vertical-spacing)">
      <div className="container">
        <SectionHeader
          title="Motion data for insight, not just animation"
          description="Build large datasets, targeted LoRAs, or style libraries to train embodied applications across industries."
        />

        <div className="flex flex-col gap-4 sm:flex-row">
          {dataProducts.map((product) => (
            <div
              key={product.title}
              className="bg-gray-90 relative aspect-square flex-1 overflow-hidden rounded-2xl p-8"
            >
              <LazyVideo
                src={product.videoUrl}
                className="opacity-48 absolute inset-0 h-full w-full rounded-[inherit]"
                mode="autoplay"
              />
              <Text
                variant="web/body/medium/lg"
                lg:variant="web/body/medium/xl"
                className="relative z-10 text-white"
              >
                {product.title}
              </Text>
            </div>
          ))}
        </div>

        <div className="mt-20">
          <GreenLink href="/data">Learn about leveraging data</GreenLink>
        </div>
      </div>
    </section>
  );
}
